import { useEffect } from 'react';
var P7Belt = function P7Belt(_ref) {
  var page = _ref.page;
  var thisPage = 3;
  useEffect(function () {
    $('.p7-belt').css({
      opacity: page === thisPage ? 1 : 0
    });
  }, [page]);
  return /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p7/posillico-conveyor.png",
    className: "p7-belt"
  });
};
export default P7Belt;